import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/Footer/Footer.component.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/Header/Header.component.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/contexts/Theme.context.jsx");
